<div class="form-group row" *ngIf="control.visible" [formGroup]="formGroup">
  <div class="col-md-12">
    <hb-df-control-label [control]="control" (onOverrideValue)="overrideValue()"></hb-df-control-label>
  </div>
  <div *ngIf="!control.textOnly; else textOnly" class="col-md-12">
    <input
      class="form-control"
      [type]="control.type || 'text'"
      [id]="control.key"
      [placeholder]="control.placeholder || control.label"
      [name]="control.key"
      [formControl]="control.formControl"
      [formControlName]="control.key"
      [attr.disabled]="control.disabled ? 'disabled' : null"
      (paste)="onPaste($event)"
      [ngClass]="{
        'is-invalid':
          control.enableValidation &&
          (control.form?.submitted || (control?.formControl?.touched && control?.showErrorsOnTouched)) &&
          control.isInvalid
      }"
    />
    <div
      *ngIf="
        control.enableValidation && (control.form?.submitted || (control?.formControl?.touched && control?.showErrorsOnTouched)) && control.isInvalid
      "
      class="primeng-invalid-feedback div-word-wrap validation-error-text"
    >
      <div *ngIf="control.formControl.errors.required" [pTooltip]="control.label + ' is required.'">{{ control.label }} is required.</div>
    </div>
  </div>
  <ng-template #textOnly>
    <div class="col-12 text-truncate" [pTooltip]="control?.value" tooltipZIndex="1051">
      {{ control?.value }}
    </div>
  </ng-template>
</div>
